"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/resale/v1/legacy_portal_service.proto (package spwn.resale.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalResaleService = void 0;
const legacy_portal_service_pb_1 = require("./legacy_portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * --- 出品者向け API ---
 *
 * @generated from service spwn.resale.v1.LegacyPortalResaleService
 */
exports.LegacyPortalResaleService = {
    typeName: "spwn.resale.v1.LegacyPortalResaleService",
    methods: {
        /**
         * リセール出品更新 API（出品登録・増減・キャンセルを一括処理）
         *
         * @generated from rpc spwn.resale.v1.LegacyPortalResaleService.UpdateResaleListing
         */
        updateResaleListing: {
            name: "UpdateResaleListing",
            I: legacy_portal_service_pb_1.LegacyPortalResaleServiceUpdateResaleListingRequest,
            O: legacy_portal_service_pb_1.LegacyPortalResaleServiceUpdateResaleListingResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 自身の出品一覧・状況取得 API
         *
         * @generated from rpc spwn.resale.v1.LegacyPortalResaleService.GetMyResaleListings
         */
        getMyResaleListings: {
            name: "GetMyResaleListings",
            I: legacy_portal_service_pb_1.LegacyPortalResaleServiceGetMyResaleListingsRequest,
            O: legacy_portal_service_pb_1.LegacyPortalResaleServiceGetMyResaleListingsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 自身の出品詳細取得 API
         *
         * @generated from rpc spwn.resale.v1.LegacyPortalResaleService.GetResaleListing
         */
        getResaleListing: {
            name: "GetResaleListing",
            I: legacy_portal_service_pb_1.LegacyPortalResaleServiceGetResaleListingRequest,
            O: legacy_portal_service_pb_1.LegacyPortalResaleServiceGetResaleListingResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * リセール回・受付状況一覧取得 API（新規申込用）
         *
         * @generated from rpc spwn.resale.v1.LegacyPortalResaleService.GetResaleRounds
         */
        getResaleRounds: {
            name: "GetResaleRounds",
            I: legacy_portal_service_pb_1.LegacyPortalResaleServiceGetResaleRoundsRequest,
            O: legacy_portal_service_pb_1.LegacyPortalResaleServiceGetResaleRoundsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 自身の申込一覧・状況取得 API（マイページ一覧用）
         *
         * @generated from rpc spwn.resale.v1.LegacyPortalResaleService.GetMyResaleApplications
         */
        getMyResaleApplications: {
            name: "GetMyResaleApplications",
            I: legacy_portal_service_pb_1.LegacyPortalResaleServiceGetMyResaleApplicationsRequest,
            O: legacy_portal_service_pb_1.LegacyPortalResaleServiceGetMyResaleApplicationsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 自身の申込詳細取得 API（申込詳細・変更・キャンセル用）
         *
         * @generated from rpc spwn.resale.v1.LegacyPortalResaleService.GetResaleApplication
         */
        getResaleApplication: {
            name: "GetResaleApplication",
            I: legacy_portal_service_pb_1.LegacyPortalResaleServiceGetResaleApplicationRequest,
            O: legacy_portal_service_pb_1.LegacyPortalResaleServiceGetResaleApplicationResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * リセール申込更新 API（新規申込・枚数増減・キャンセルを一括処理）
         *
         * @generated from rpc spwn.resale.v1.LegacyPortalResaleService.UpdateResaleApplication
         */
        updateResaleApplication: {
            name: "UpdateResaleApplication",
            I: legacy_portal_service_pb_1.LegacyPortalResaleServiceUpdateResaleApplicationRequest,
            O: legacy_portal_service_pb_1.LegacyPortalResaleServiceUpdateResaleApplicationResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map